import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import BasicLeftInfo from "../../section/JobSection/BasicLeftInfo";
import JobDesRightInfo from "../../section/JobSection/JobDesRightInfo";
import RejectBox from "../../section/JobSection/RejectBox";
import { BASE_URL_2 } from "../../../customHooks/config";
import { useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "../../layout/loader/Spinner";
import { USER_DETAILS } from "../../layout/Layout";
import { useAtom } from "jotai";
import LeftInfoSkeleton from "../../section/JobSection/LeftInfoSkeleton";
import RightInfoSkeleton from "../../section/JobSection/RightInfoSkeleton";
import ActionHistory from "../../section/JobSection/ActionHistory";
import { USER_DETAILS_UPDATE_UPLOAD_DAILOG } from "../../section/JobSection/UploadDialog";
import { toast } from "react-toastify";

function JobDetails() {
  const params = useParams();
  const [details, setDetails] = useState(null);
  const [isRejected, setIsRejected] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [rejected, setRejected] = useState(false);
  const [userDetails] = useAtom(USER_DETAILS);
  const [uploadJobDes] = useAtom(USER_DETAILS_UPDATE_UPLOAD_DAILOG);
  const statusForShowingPopUp = userDetails?.data?.user_details?.vendor_status;

  // const location = useLocation();
  const [state, setState] = useState({
    status: "",
    create_time: "",
    reject_reason: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_URL_2}job/vendor/job_details/?job_id=${params.id}`, {
        withCredentials: true,
      })
      .then((res) => {
        setDetails(res?.data?.data);
        setLoading(false);
        setState({
          ...state,
          status: res?.data?.data?.vendor_job_status,
          reject_reason: res?.data?.data?.reject_reason,
          create_time: res?.data?.data?.job_status_update_date,
          job_status: res?.data?.data?.job_status,
        });
      })
      .catch((err) => {
        toast.error(err?.data?.error);
        setLoading(false);
      });
  }, [rejected, isAccepted, uploadJobDes]);

  return !state?.status ? (
    <>
      <>
        <div className="fixed top-[5px] w-[100%]  ">
          {window.location.pathname.includes("/job-details") && (
            <div className="absolute top-[72px]">
              <nav className="flex" aria-label="Breadcrumb">
                <ol className="inline-flex items-center space-x-1 md:space-x-3">
                  <li className="inline-flex items-center">
                    {statusForShowingPopUp === "PENDING" ||
                    statusForShowingPopUp === "REJECTED" ? (
                      <a
                        href="/all-jobs/4"
                        style={{ fontFamily: "gilRoy-semibold" }}
                        className="inline-flex items-center text-xs font-medium text-[#6C757D] hover:text-blue-600 "
                      >
                        Job
                      </a>
                    ) : (
                      <a
                        href="/all-jobs/1"
                        style={{ fontFamily: "gilRoy-semibold" }}
                        className="inline-flex items-center text-xs font-medium text-[#6C757D] hover:text-blue-600 "
                      >
                        Job
                      </a>
                    )}
                  </li>
                  <li style={{ marginLeft: 0 }}>
                    <div
                      className="flex items-center"
                      style={{ fontFamily: "gilRoy-semibold" }}
                    >
                      <ChevronRightIcon className="w-3 h-3  text-[#6C757D]" />

                      <a
                        href=""
                        className=" text-xs font-medium  text-[#6C757D] hover:text-blue-600"
                      >
                        Job Details
                      </a>
                    </div>
                  </li>
                </ol>
              </nav>
            </div>
          )}
        </div>
        <div className=" w-full flex relative pt-4">
          {loading ? (
            <div className="absolute top-[50%] left-[50%]">
              <Spinner />
            </div>
          ) : (
            <>
              <div className="w-[25%] z-[100]  h-fit sticky top-[16px] mr-[40px] mb-5">
                <BasicLeftInfo
                  data={details}
                  state={state}
                  jobId={params.id}
                  setRejected={setRejected}
                  setIsAccepted={setIsAccepted}
                />
                {/* {state?.status === "ACCEPTED" || state?.status === "PENDING" ? (
                <></>
              ) : (
                <RejectBox state={state} />
              )} */}
              </div>
              <div className="w-[70%]  ">
                <div className=" border bg-white  border-[#CBD5E1]  rounded-lg p-5">
                  <JobDesRightInfo data={details} />
                </div>

                <div className="  border bg-white  border-[#CBD5E1]  rounded-lg p-5 mt-5 mb-5">
                  <ActionHistory data={details} />
                </div>
              </div>
            </>
          )}
        </div>
      </>
    </>
  ) : (
    // <Layout>
    <>
      <div className="fixed top-[5px] w-[100%]  ">
        {window.location.pathname.includes("/job-details") && (
          <div className="absolute top-[72px]">
            <nav className="flex" aria-label="Breadcrumb">
              <ol className="inline-flex items-center space-x-1 md:space-x-3">
                <li className="inline-flex items-center">
                  <a
                    href="/all-jobs/1"
                    style={{ fontFamily: "gilRoy-semibold" }}
                    className="inline-flex items-center text-xs font-medium text-[#6C757D] hover:text-blue-600 "
                  >
                    Job
                  </a>
                </li>
                <li style={{ marginLeft: 0 }}>
                  <div
                    className="flex items-center"
                    style={{ fontFamily: "gilRoy-semibold" }}
                  >
                    <ChevronRightIcon className="w-3 h-3  text-[#6C757D]" />

                    <a
                      href=""
                      className=" text-xs font-medium  text-[#6C757D] hover:text-blue-600"
                    >
                      Job Details
                    </a>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
        )}
      </div>
      <div className=" w-full flex relative pt-4">
        {loading ? (
          <div className="absolute top-[50%] left-[50%]">
            <Spinner />
          </div>
        ) : (
          <>
            <div className="w-[25%] z-[100]  h-fit sticky top-[16px] mr-[40px] mb-5">
              <BasicLeftInfo
                data={details}
                state={state}
                jobId={params.id}
                setRejected={setRejected}
                setIsAccepted={setIsAccepted}
              />
              {state?.status === "ACCEPTED" || state?.status === "PENDING" ? (
                <></>
              ) : (
                <RejectBox state={state} />
              )}
            </div>
            <div className="w-[70%]  ">
              <div className=" border bg-white  border-[#CBD5E1]  rounded-lg p-5">
                <JobDesRightInfo data={details} />
              </div>

              <div className="  border bg-white  border-[#CBD5E1]  rounded-lg p-5 mt-5 mb-5">
                <ActionHistory data={details} />
              </div>
            </div>
          </>
        )}
      </div>
    </>
    // </Layout>
  );
}

export default JobDetails;
